
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { addSchedulingShifts, editSchedulingShifts } from '@/api/groupScheduling';

@Component({
  name: 'setShifts',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  DialogSetShifts!: Boolean;
  @Prop({
    type: Number,
    default: 1
  })
  shiftsOperate!: Number;
  @Prop({
    type: Object,
    default: () => {}
  })
  shiftsData!: any;

  private shiftsDisable = false
  private shiftsForm: any = {
    name: '',
    isAcrossDay: '1',
    startTime: '',
    endTime: ''
  }

  created() {
    if (this.shiftsOperate === 2) {
      this.shiftsForm.name = this.shiftsData.shifts_name;
      this.shiftsForm.isAcrossDay = this.shiftsData.is_skip_day === '0' ? '1' : '2';
      this.shiftsForm.startTime = this.shiftsData.start_time;
      this.shiftsForm.endTime = this.shiftsData.end_time;
    } else {
      this.shiftsForm = {
        name: '',
        isAcrossDay: '1',
        startTime: '',
        endTime: ''
      };
    }
  }

  private submitShifts() {
    if (!this.shiftsForm.name) {
      this.showErrorMsg('请输入班次名');
      return;
    }
    if (!this.shiftsForm.startTime) {
      this.showErrorMsg('请选择上班时间');
      return;
    }
    if (!this.shiftsForm.endTime) {
      this.showErrorMsg('请选择下班时间');
      return;
    }
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };

    pamars.shifts_name = this.shiftsForm.name;
    pamars.start_time = this.shiftsForm.startTime;
    pamars.end_time = this.shiftsForm.endTime;
    pamars.is_skip_day = this.shiftsForm.isAcrossDay === '1' ? '0' : '1';
    pamars.group_id = this.shiftsData.groupId;
    if (this.shiftsOperate === 2) {
      pamars.shifts_id = this.shiftsData.id;
      editSchedulingShifts(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.$emit('confirm');
        this.$emit('close', false);
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addSchedulingShifts(pamars).then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.$emit('confirm');
        this.$emit('close', false);
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }

  close() {
    this.$emit('close', false);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
